import { useState } from 'react';
import { useNavigate } from 'react-router-dom'

import CancelButton from '../components/psc/lib/CancelButton'
import Confirm from '../components/psc/lib/Confirm'

import useAuthentication from '../hooks/useAuthentication';
import useUserManagement from '../hooks/useUserManagement';
import useBrowserTabTitle from '../hooks/useBrowserTabTitle';

const Security = () => {
    useBrowserTabTitle('Security')

    const navigate = useNavigate()
    const [submitActive, setSubmitActive] = useState(false)
    
    const {
        currentUser,
        updateUser: updateCurrentUser,
    } = useAuthentication();

    const {
        activeUsers,
        updateUser,
        saveUserUpdates,
    } = useUserManagement()

    const handleSubmit = (event) => {
        event.preventDefault()

        setSubmitActive(true)
        saveUserUpdates()

        // We might have changed setting on ourself. So need to reload what's in pscState.. #sigh
        const currentUpdate = { ...currentUser }
        const currentDetails = activeUsers.find(i => i.id === currentUser.id)
        currentUpdate.is_2fa_required = currentDetails.is_2fa_required
        currentUpdate.is_2fa_configured = currentDetails.is_2fa_configured
        updateCurrentUser(currentUpdate);
        
        const data = activeUsers.map(i => {
            return {
                id: i.id,
                is_2fa_required: i.is_2fa_required,
                is_2fa_configured: i.is_2fa_configured,
            }
        })
        
        // Update permissions
        fetch('/v0/users', {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(res => res.ok ? navigate('/users') : Promise.reject(res))
        .catch(err => alert('Could not save Users 2FA data. Please contact IT support'))
    }

    const render2FAStatus = (user) => {
        if (user.is_2fa_configured) {
            return (
                <div>
                    <strong>
                        <i className="fa fa-shield"></i> 2FA Active
                        <Confirm
                            onConfirm={() => updateUser(user.id, { is_2fa_configured: false })}
                            bodyContent="Are you sure you want to reset this? You need to press Save Changes on the page to effect this change."
                            confirmText="Confirm Reset"
                            title="Reset">
                            <button type="button" className="btn btn-xs btn-delete">
                                Reset
                            </button>
                        </Confirm>
                    </strong>
                </div>
            )
        }
        if (user.is_2fa_required) {
            return (
                <strong>
                    <i className="fa fa-shield"></i> 2FA Enabled (awaiting User Activation)
                </strong>
            )
        }

        return (
            <strong>
                Not Enabled
            </strong>
        )
    }

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>
                                Security
                            </h2>
                        </div>
                        <div className="ibox-content">
                            <form className="form-horizontal" onSubmit={(e) => handleSubmit(e)}>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label"></label>

                                    <div className="col-sm-8">
                                        <h3>Two Factor Authentication</h3>
                                        <p>Set 2FA options for all Users</p>
                                        <table className="table">
                                            <tbody>
                                                {activeUsers.map(function(item) {
                                                     return (
                                                         <tr key={item.id}>
                                                            <td>
                                                                {item.forename} {item.surname}
                                                            </td>
                                                            <td>
                                                                <div className="btn-group">
                                                                    <button
                                                                        className={item.is_2fa_required ? 'btn btn-sm btn-white' : 'btn btn-sm btn-primary'}
                                                                        type="button"
                                                                        onClick={() => updateUser(item.id, { is_2fa_required: false } )}
                                                                        data-tooltip-id="gnctooltip" data-tooltip-content="User can decide if they want to use Two Factor Authentication"
                                                                    >
                                                                        Optional
                                                                    </button>
                                                                    <button
                                                                        className={item.is_2fa_required ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-white'}
                                                                        type="button"
                                                                        onClick={() => updateUser(item.id, { is_2fa_required: true } )}
                                                                        data-tooltip-id="gnctooltip" data-tooltip-content="User is forced to use Two Factor Authentication"
                                                                    >
                                                                        Required
                                                                    </button>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {render2FAStatus(item)}
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="hr-line-dashed"></div>

                                <div className="form-group">
                                    <div className="col-sm-8 col-sm-offset-2">
                                        <CancelButton />

                                        <button className={'btn btn-mr btn-primary has-spinner ' + (submitActive ? 'active' : '')} type="submit">
                                            <span className="psc-spinner"><i className="fa fa-refresh fa-spin fa-fw"></i></span>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Security
